const isLegacyBrowser = () => {
    const ua = window.navigator.userAgent;
    const isIe = ua.indexOf('MSIE ') !== -1;
    const isTrident = ua.indexOf('Trident/') !== -1;

    return isIe || isTrident;
}

export {
    isLegacyBrowser
}